export default __webpack_public_path__ + "static/media/architecture-6.158f5772.webp";